import { useEffect, useMemo, useState } from 'react';
import { Image, Tag } from "antd";
import './Feedback.css';

const DietRecommendation = ({ title, mediaMap, fieldKey }: any) => {
    const items = mediaMap.get(fieldKey)?.extData?.list || [];
    return (
        <div className="box">
            <div>{title}</div>
            <div className="box">
                {items.map((item: any, index: number) => (
                    <div key={index}>
                        <div className="food">{item.food}</div>
                        <div><span className="span-title">食材</span> : {item.ingredients}</div>
                        <div><span className="span-title">做法</span> : {item.instructions}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

const ListSection = ({ mediaMap, fieldKey, title }: any) => {
    const items = mediaMap.get(fieldKey)?.extData?.list || [];
    return (
        <div className="box">
            <div className="title">{title}</div>
            <div className="box">
                {items.map((item: any, index: number) => (
                    <div key={index}>
                        <span className="span-title">{item.title}</span> : {item.content}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default function PulseResult({ dataList, id }: any) {
    const [showError, setShowError] = useState(false);

    const expandedData = useMemo(() => {
        if (!dataList) return undefined;
        return dataList?.find((item: any) => item?.id === id);
    }, [dataList, id]);

    const mediaMap = useMemo(() => {
        const map = new Map();
        const mediaList = expandedData?.pulseDetail?.mediaList || [];
        mediaList.forEach((media: any) => {
            map.set(media.fieldKey, media);
        });
        return map;
    }, [expandedData]);

    useEffect(() => {
        let timer: NodeJS.Timeout;

        if (dataList !== undefined && !expandedData) {
            timer = setTimeout(() => {
                setShowError(true);
            }, 300);
        } else if (expandedData) {
            setShowError(false);
        }

        return () => {
            if (timer) clearTimeout(timer);
        };
    }, [dataList, expandedData]);

    if (dataList === undefined && !expandedData) {
        return <div>加载中...</div>;
    }

    if (showError && !expandedData) {
        return <div>检测结果不存在或已被删除</div>;
    }

    if (!expandedData) {
        return <div>加载中...</div>;
    }

    const renderImages = () => {
        const pictures = mediaMap.get('pulse_images')?.extData?.pictures || [];
        return pictures.map((item: any, index: number) => (
            <Image
                key={index}
                src={item.picturePath}
                alt={item.pictureName}
                style={{ marginBottom: 10 }}
                preview={false}
            />
        ));
    };

    const renderVideo = () => {
        const videoPath = mediaMap.get('pulse_video')?.extData?.videoPath;
        if (!videoPath) {
            return '视频加载失败';
        }

        return (
            <video
                src={videoPath}
                controls
                style={{ width: '100%', marginBottom: 10 }}
                preload="metadata"
            >
                您的浏览器不支持视频播放。
            </video>
        );
    };

    return (
        <div className="expandRow">
            <div style={{ width: '23%' }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    position: 'relative',
                    paddingTop: '12px',
                    paddingBottom: '12px'
                }}>
                    <div style={{ position: 'absolute', top: 0, right: 0 }}>
                        {expandedData?.measurementType == 'WATCH' ?
                            <Tag style={{ backgroundColor: '#F6EBD4', color: '#B9792B' }}>
                                手表测量
                            </Tag> :
                            <Tag style={{ backgroundColor: '#e8f5e9', color: '#4A9C41' }}>
                                指尖测量
                            </Tag>
                        }</div>
                    <div className="pulseType">{expandedData?.pulseType}</div>
                    <div className="createAt">{expandedData?.createAt}</div>
                </div>
                <div className="diagnosis-video-title">{mediaMap.get('conclusion')?.extData?.description}</div>
                <div>{renderImages()}</div>
                {/* <div>{renderVideo()}</div> */}

                <div className="video-description">
                    <div className="video-box" style={{ marginRight: "15px" }}>
                        <div className="video-title">表现</div>
                        <div className="video-content">{mediaMap.get('common_symptom')?.extData?.description}</div>
                    </div>
                    <div className="video-box">
                        <div className="video-title">建议</div>
                        <div className="video-content">{mediaMap.get('suggestion')?.extData?.description}</div>
                    </div>
                </div>

                <div className="title">脉象数据</div>
                <div className="box" style={{ display: 'flex', justifyContent: 'space-around' }}>
                    <div style={{ textAlign: 'center' }}>
                        <div className="pulse-title">频率</div>
                        <div className="pulse-content">{mediaMap.get('frequency')?.extData?.description}</div>
                    </div>
                    <div className="divider"></div>
                    <div style={{ textAlign: 'center' }}>
                        <div className="pulse-title">脉力</div>
                        <div className="pulse-content">{mediaMap.get('pulse_strength')?.extData?.description}</div>
                    </div>
                    <div className="divider"></div>
                    <div style={{ textAlign: 'center' }}>
                        <div className="pulse-title">脉势</div>
                        <div className="pulse-content">{mediaMap.get('pulse_momentum')?.extData?.description}</div>
                    </div>
                </div>

                <div className="title">特征</div>
                <div className="box">
                    <span className="span-title">特征</span> : {expandedData?.pulseDetail?.description}
                </div>

                <div className="title">主病</div>
                <div className="box">
                    <span className="span-title">主病</span> : {mediaMap.get('primary_indication')?.extData?.description}
                </div>

                <div className="title">脉象宜忌</div>
                <div>宜</div>
                <div className="box">
                    {mediaMap.get('pulse_indication')?.extData?.list?.map((item: any, index: number) => (
                        <div key={index}><span className="span-title">{item.title}</span> : {item.content}</div>
                    ))}
                </div>
                <div>忌</div>
                <div className="box">
                    {mediaMap.get('pulse_contraindication')?.extData?.list?.map((item: any, index: number) => (
                        <div key={index}><span className="span-title">{item.title}</span> : {item.content}</div>
                    ))}
                </div>
            </div>

            <div style={{ width: '23%' }}>
                <ListSection mediaMap={mediaMap} fieldKey="lifestyle_routine" title="生活作息" />
                <ListSection mediaMap={mediaMap} fieldKey="mood_regulation" title="心情调节" />
            </div>

            <div style={{ width: '23%' }}>
                <div className="title">饮食建议</div>
                <DietRecommendation title="早餐" mediaMap={mediaMap} fieldKey="diet_breakfast" />
                <DietRecommendation title="午餐" mediaMap={mediaMap} fieldKey="diet_lunch" />
            </div>

            <div style={{ width: '23%' }}>
                <DietRecommendation title="晚餐" mediaMap={mediaMap} fieldKey="diet_dinner" />
                <ListSection mediaMap={mediaMap} fieldKey="exercise_adjustment" title="运动调节" />
            </div>
        </div>
    );
}